import * as React from 'react';

var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgHeartOutline16 = function SvgHeartOutline16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.624 13.858.348.338.349-.336 6.16-5.948.005-.006a3.413 3.413 0 0 0-.04-4.895h-.001c-1.396-1.347-3.66-1.348-5.06 0L8 4.349 6.553 2.952l-.005-.005-.005-.004A3.64 3.64 0 0 0 4.086 2c-.912 0-1.83.335-2.53 1.011a3.412 3.412 0 0 0-.001 4.935l6.07 5.912z",
    stroke: "currentColor"
  })));
};

var HeartOutline16Svg = SvgHeartOutline16;

export { HeartOutline16Svg as default };
//# sourceMappingURL=HeartOutline16.svg.js.map
